import { Row, Col, Collapse, } from "antd";
import { useTranslation } from "react-i18next";
import { PATH } from "../../routes/Routes";
import { useHistory } from "react-router-dom";
import { PRIMARY_COLOR, WHITE_COLOR } from "../../constance/color";
import { RightOutlined } from "@ant-design/icons";

export default function ReportView() {
    const { t } = useTranslation();
    const history = useHistory();

    const reportMenu = [{ id: "log_wood" }, { id: "wood_import" }, { id: "waste_wood" },];

    const log_woodItems = [
        {
            label: (<div style={{ color: WHITE_COLOR, fontSize: '16px' }}>{t("menus.report_menus.log_wood")}</div>),
            children: (
                <div>
                    <div><a onClick={() => handleMenuClick(PATH.REPORT_LOG_WOOD_LENGTH)}>
                        {t("menus.report_menus.log_wood_menus.log_wood_length")}</a></div>
                    <div><a onClick={() => handleMenuClick(PATH.REPORT_LOG_WOOD_LENGTH_COMPANY)}>
                        {t("menus.report_menus.log_wood_menus.log_wood_length_by_customer")}</a></div>
                    <div><a onClick={() => handleMenuClick(PATH.REPORT_LOG_WOOD_SPECIES)}>
                        {t("menus.report_menus.log_wood_menus.log_wood_species")}</a></div>
                    <div><a onClick={() => handleMenuClick(PATH.REPORT_LOG_WOOD_SPECIES_COMPANY)}>
                        {t("menus.report_menus.log_wood_menus.log_wood_species_by_customer")}</a></div>
                    <div><a onClick={() => handleMenuClick(PATH.REPORT_LOG_WOOD_CUT_WEIGHT)}>
                        {t("menus.report_menus.log_wood_menus.cut_weight")}</a></div>
                </div>
            ),
        },
    ];

    const wood_importItems = [
        {
            label: (<div style={{ color: WHITE_COLOR, fontSize: '16px' }}>{t('menus.report_menus.wood_import')}</div>),
            children: (
                <div>
                    <div><a onClick={() => handleMenuClick(PATH.REPORT_WOOD_IMPORT)} >
                        {t("menus.report_menus.wood_import_menus.wood_import_detail")}</a></div>
                    <div><a onClick={() => handleMenuClick(PATH.REPORT_WOOD_IMPORT_COMPANY)}>
                        {t("menus.report_menus.wood_import_menus.wood_import_by_customer")}</a></div>
                    <div><a onClick={() => handleMenuClick(PATH.REPORT_WOOD_IMPORT_COMPANY_DATE)}>
                        {t("menus.report_menus.wood_import_menus.wood_import_by_customer_and_date")}</a></div>
                    <div><a onClick={() => handleMenuClick(PATH.REPORT_WOOD_IMPORT_THICK)}>
                        {t("menus.report_menus.wood_import_menus.wood_import_by_width")}</a></div>
                    <div><a onClick={() => handleMenuClick(PATH.REPORT_WOOD_IMPORT_VOLUME)}>
                        {t("menus.report_menus.wood_import_menus.wood_import_by_volume")}</a></div>
                    <div><a onClick={() => handleMenuClick(PATH.REPORT_WOOD_IMPORT_WOOD_CODE)}>
                        {t("menus.report_menus.wood_import_menus.wood_import_by_wood_code")}</a></div>
                    <div><a onClick={() => handleMenuClick(PATH.REPORT_WOOD_IMPORT_OUT_GRADE)}>
                        {t("menus.report_menus.wood_import_menus.wood_import_out_grade")}</a></div>
                </div>
            ),
        },
    ];

    const waste_woodItems = [
        {
            label: (<div style={{ color: WHITE_COLOR, fontSize: '16px' }}>{t('menus.report_menus.waste_wood')}</div>),
            children: (
                <div>
                    <div><a onClick={() => handleMenuClick(PATH.POST_BAKING_WASTE_WOOD_COUNT_REPORT)}>
                        {t("menus.report_menus.waste_woods.post_baking_waste_wood_count")}</a></div>
                    <div><a onClick={() => handleMenuClick(PATH.POST_BAKING_WASTE_WOOD_INPUT_REPORT)}>
                        {t("menus.report_menus.waste_woods.post_baking_waste_wood_input")}</a></div>
                    <div><a onClick={() => handleMenuClick(PATH.POST_BAKING_WASTE_WOOD_SUMMARY_REPORT)}>
                        {t("menus.report_menus.waste_woods.post_baking_waste_wood_summary")}</a></div>
                    <div><a onClick={() => handleMenuClick(PATH.POST_BAKING_WASTE_WOOD_INPUT_SUMMARY_REPORT)}>
                        {t("menus.report_menus.waste_woods.post_baking_waste_wood_input_summary")}</a></div>
                </div>
            ),
        },
    ];

    const handleMenuClick = (path) => {
        history.push(path);
    };

    return (
        <div>
            {reportMenu.map((menu) => {
                let menuItems = [];

                if (menu.id === "log_wood") {
                    menuItems = log_woodItems;
                } else if (menu.id === "wood_import") {
                    menuItems = wood_importItems;
                } else if (menu.id === "waste_wood") {
                    menuItems = waste_woodItems;
                }
                return (
                    <Row>
                        <Col
                            xs={{ offset: 2, span: 24 }}
                            sm={{ offset: 7, span: 12 }}
                            lg={{ offset: 9, span: 8 }}
                            md={{ offset: 7, span: 13 }}>
                            <br />
                            <Collapse items={menuItems} size='small' expandIconPosition="end"
                                style={{ textAlign: 'left', backgroundColor: PRIMARY_COLOR, width: "80%" }}
                                expandIcon={({ isActive }) =>
                                    <RightOutlined rotate={isActive ? 90 : 0} style={{ color: WHITE_COLOR, fontSize: '16px' }} />}
                            />
                        </Col>
                    </Row>
                )
            }
            )}
        </div>
    );
}